// 解析JWT Token并验证
function parseJwt(token) {
  try {
    // 获取载荷部分（第二部分）
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // 解码
    const payload = JSON.parse(window.atob(base64));
    
    // 检查是否过期
    const currentTime = Math.floor(Date.now() / 1000);
    if (payload.exp && payload.exp < currentTime) {
      return {
        valid: false,
        expired: true,
        payload
      };
    }
    
    return {
      valid: true,
      expired: false,
      payload
    };
  } catch (e) {
    console.error('Token解析错误:', e);
    return {
      valid: false,
      expired: false,
      error: e.message
    };
  }
}

// 测试当前使用的token
export function testCurrentToken() {
  const token = localStorage.getItem('token') || 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxIiwiY3JlYXRlZCI6MTc0NTg5ODQ0NjE1MywiZXhwIjoxNzQ2NTAzMjQ2fQ.lqX5Y1qAWD41WJG9m8IxUetWaevD79D4tSrPY_HqPnDUmA-ZPcCwQmY9LRlDodyPGgpr9kDhLrY4s7mDUJe7Cg';
  
  const result = parseJwt(token);
  console.log('Token检查结果:', result);
  
  if (!result.valid) {
    if (result.expired) {
      console.warn('警告: Token已过期！');
    } else {
      console.error('错误: Token无效！');
    }
  } else {
    console.log('Token有效，包含以下信息:');
    console.log('用户ID:', result.payload.sub);
    console.log('创建时间:', new Date(result.payload.created).toLocaleString());
    console.log('过期时间:', new Date(result.payload.exp * 1000).toLocaleString());
  }
  
  return result;
}

export default { parseJwt, testCurrentToken }; 